// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { formatWorkflowsDate } from "../../../../utils";
import {
  DetailsHeading,
  DetailsSubheading,
  SecureDetailsContent,
  SecureDetailsList,
} from "../../styles";
import { ResidentProfileProps } from "../../types";

export function UsMoSolitary({
  resident,
}: ResidentProfileProps): React.ReactElement<any> | null {
  const { metadata } = resident;

  if (metadata.stateCode !== "US_MO") return null;

  const { solitaryAssignmentInfoPastYear, numSolitaryAssignmentsPastYear } =
    metadata;

  const SOLITARY_CONFINEMENT_DATE_COPY = (
    solitaryStartDate: Date | undefined,
    solitaryEndDate: Date | undefined,
  ) => {
    const startDateText = solitaryStartDate
      ? formatWorkflowsDate(solitaryStartDate)
      : "START DATE UNAVAILABLE";
    const endDateText =
      solitaryEndDate !== undefined
        ? formatWorkflowsDate(solitaryEndDate)
        : "Present";
    return `${startDateText} - ${endDateText}`;
  };

  return (
    <SecureDetailsList>
      <DetailsHeading>Restrictive Housing Assignments</DetailsHeading>
      <DetailsSubheading>
        Restrictive Housing Assignments in Past Year
      </DetailsSubheading>
      {solitaryAssignmentInfoPastYear &&
      solitaryAssignmentInfoPastYear.length > 0 ? (
        solitaryAssignmentInfoPastYear.map(({ startDate, endDate }) => {
          return (
            <SecureDetailsContent key={`${startDate}${endDate}`}>
              {SOLITARY_CONFINEMENT_DATE_COPY(startDate, endDate)}
            </SecureDetailsContent>
          );
        })
      ) : (
        <SecureDetailsContent>None</SecureDetailsContent>
      )}
      <DetailsSubheading>
        Number of Restrictive Housing Assignments in Past Year
      </DetailsSubheading>
      <SecureDetailsContent>
        {numSolitaryAssignmentsPastYear}
      </SecureDetailsContent>
    </SecureDetailsList>
  );
}
